import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const token = localStorage.getItem("pos_access_token");

  // 🔥 Block ALL invalid or empty tokens
  if (!token || token.trim() === "" || token === "undefined") {
    return <Navigate to="/signin" replace />;
  }

  return children;
}
